export default __webpack_public_path__ + "static/media/header-home-active-icon.e7339cf3.svg";